export interface VoiceInputProps {
  onRecordingComplete?: (audioBlob: Blob) => void;
  onRecordingStart?: () => void;
  onRecordingStop?: () => void;
  onError?: (error: Error) => void;
  maxDuration?: number;
  disabled?: boolean;
  className?: string;
  onRecordingStateChange?: (isRecording: boolean) => void;
}

export interface RecordingError extends Error {
  code?: string;
  type: 'permission' | 'not-supported' | 'unknown';
}

export const createRecordingError = (
  message: string,
  type: RecordingError['type'],
  code?: string,
): RecordingError => {
  const error = new Error(message) as RecordingError;
  error.type = type;
  error.code = code;
  return error;
};
